import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { Input, AutoComplete, Layout, Cell, Box } from 'wix-style-react';
var AddressInput = /** @class */ (function (_super) {
    __extends(AddressInput, _super);
    function AddressInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onStreetChange = function (address) {
            _this.props.onValueChange({
                address: address,
            });
        };
        _this.onCityChange = function (city) {
            _this.props.onValueChange({
                city: city,
            });
        };
        _this.onPostalCodeChange = function (postalCode) {
            _this.props.onValueChange({
                postalCode: postalCode,
            });
        };
        _this.onCountryChange = function (country) {
            _this.props.onValueChange({
                country: country,
            });
        };
        _this.onRegionChange = function (region) {
            _this.props.onValueChange({
                region: region,
            });
        };
        _this.getCountryDisplayValue = function (countryId) {
            var countries = _this.props.countries;
            var country = countries.find(function (c) { return c.id === countryId; });
            if (!country) {
                return '';
            }
            return country.value;
        };
        _this.getSubdivisionDisplayValue = function (subdivionsId, subdivisions) {
            if (!subdivisions) {
                return '';
            }
            var subdivision = subdivisions.find(function (s) { return s.key === subdivionsId; });
            if (!subdivision) {
                return '';
            }
            return subdivision.displayName;
        };
        _this.getCountrySubdivisions = function (countryId) {
            var countries = _this.props.countries;
            var country = countries.find(function (c) { return c.id === countryId; });
            if (!country) {
                return null;
            }
            return country.subdivisions;
        };
        _this.state = {
            countrySearchValue: '',
            subdivisionSearchValue: '',
        };
        return _this;
    }
    AddressInput.prototype.convertSubdivisionToOption = function (subdivisions) {
        var _this = this;
        return subdivisions.map(function (subdivision) { return ({
            id: subdivision.key,
            key: subdivision.key,
            value: _this.props.t(subdivision.displayName),
        }); });
    };
    AddressInput.prototype.renderSubdivisions = function (subdivisions) {
        var _this = this;
        var t = this.props.t;
        var subdivisionDisplayName = this.getSubdivisionDisplayValue(this.props.value.region, subdivisions.list);
        return (React.createElement(AutoComplete, { dataHook: "address-subdivision-input", options: this.convertSubdivisionToOption(subdivisions.list), placeholder: this.props.t(subdivisions.displayName), onSelect: function (e) {
                _this.onRegionChange(e.key);
            }, onChange: function (e) {
                _this.setState({ subdivisionSearchValue: e.target.value });
                _this.onRegionChange('');
            }, value: subdivisionDisplayName
                ? this.props.t(subdivisionDisplayName)
                : this.state.subdivisionSearchValue, predicate: function (option) {
                return _this.predicate(option, _this.state.subdivisionSearchValue);
            }, emptyStateMessage: t('editContact.field.address.emptyStatusMessage', {
                value: this.state.subdivisionSearchValue,
            }) }));
    };
    AddressInput.prototype.predicate = function (option, source) {
        return (option.value.toLowerCase().indexOf(source.toLowerCase()) !==
            -1);
    };
    AddressInput.prototype.render = function () {
        var _this = this;
        var t = this.props.t;
        var countryDisplayName = this.getCountryDisplayValue(this.props.value.country);
        var subdivisions = this.getCountrySubdivisions(this.props.value.country);
        return (React.createElement(Layout, { gap: 0 },
            React.createElement(Cell, { span: 12 },
                React.createElement(Input, { dataHook: "address-address-input", placeholder: t('editContact.field.address.placeholder.address'), onChange: function (e) {
                        return _this.onStreetChange(e.currentTarget.value);
                    }, value: this.props.value.address }),
                React.createElement(Box, { marginTop: 1 }),
                React.createElement(Layout, { gap: 6 },
                    React.createElement(Cell, { span: 6 },
                        React.createElement(Input, { dataHook: "address-city-input", placeholder: t('editContact.field.address.placeholder.city'), onChange: function (e) {
                                _this.onCityChange(e.currentTarget.value);
                            }, value: this.props.value.city })),
                    React.createElement(Cell, { span: 6 },
                        React.createElement(Input, { dataHook: "address-postalCode-input", placeholder: t('editContact.field.address.placeholder.postalCode'), onChange: function (e) {
                                return _this.onPostalCodeChange(e.currentTarget.value);
                            }, value: this.props.value.postalCode }))),
                React.createElement(Box, { marginTop: 1 }),
                React.createElement(Layout, { gap: 6 },
                    React.createElement(Cell, { span: 6 },
                        React.createElement(AutoComplete, { dataHook: "address-country-input", placeholder: t('editContact.field.address.placeholder.country'), onSelect: function (e) { return _this.onCountryChange(e.id); }, options: this.props.countries, value: countryDisplayName || this.state.countrySearchValue || '', onChange: function (e) {
                                _this.setState({
                                    countrySearchValue: e.target.value,
                                });
                                _this.onCountryChange('');
                            }, predicate: function (option) {
                                return _this.predicate(option, _this.state.countrySearchValue);
                            }, emptyStateMessage: t('editContact.field.address.emptyStatusMessage', { value: this.state.countrySearchValue }), popoverProps: {
                                appendTo: 'parent',
                            } })),
                    React.createElement(Cell, { span: 6 }, subdivisions && this.renderSubdivisions(subdivisions))))));
    };
    return AddressInput;
}(React.PureComponent));
export default translate()(AddressInput);
//# sourceMappingURL=AddressInput.js.map